import customAreaPointToJson from "../custom_area_point/mapper_to_json";

export default function createCustomAreaDataToJson(createCustomAreaData) {
    return {
        'company_id': parseInt(createCustomAreaData.companyId),
        'area_points': createCustomAreaData.areaPoints.map((point) => customAreaPointToJson(point)),
        'description': createCustomAreaData.name
    }
}
